export enum entityType {
  typeCustomer = "Customer",
  typePrincipal = "Principal",
}
